import {assertObjectType, getNamedType, GraphQLObjectType} from 'query-api-graphql';

import {GraphQLField} from 'query-api/graphql-field-selector/GraphQLFieldSelectorTypes';

export function getAndAssertObjectType(field: GraphQLField): GraphQLObjectType {
  return assertObjectType(getNamedType(field.type));
}
